<div class="p8-bdc_edit-text__container">
  <quill-editor [(ngModel)]="block.value"
                [modules]="modules"
                [formats]="formats"
                [placeholder]="'Ajouter du texte ici ...'"
                (onContentChanged)="onQuillChanged($event)">
  </quill-editor>
</div>
